import { VideoState } from "@/components/VideoPage/redux/types";

export const videoInitialState: VideoState = {
  videoData: null,
  error: null,
  loading: false,
  ua: undefined,
  videoSlug: null,
};
